/* eslint-disable */
import React from 'react'
import { Card, CardBody } from 'reactstrap'
import ButtonsWarehouse from './ButtonsWarehouse'


const DetailsWarehouse = (props) => {
    const { id } = props
    return (
        <Card>
            <CardBody>
                <ButtonsWarehouse id={id}></ButtonsWarehouse>
                <p>Quantità magazzino: { } </p>
                <p>Data Primo Carico: { } </p>
                <p>Data Ultimo Carico: { } </p>
                <p>Data Primo Scarico: { } </p>
                <p>Data Ultimo Scarico: { } </p>
            </CardBody>
        </Card>
    )
}

export default DetailsWarehouse